import { useAtomValue } from 'jotai/index';
import {
	detailedPricingStartingCostAtom,
	detailedPricingUsuallySpendAtom,
} from '../jotai/storefront/detailed-pricing';
import {
	couplesUsuallySpendAtom,
	startingCostAtom,
} from '../jotai/storefront/pricing';

export const useEstimatedPricing = () => {
	const couplesUsuallySpendDetailedPricing = useAtomValue(
		detailedPricingUsuallySpendAtom,
	);
	const couplesUsuallySpend = useAtomValue(couplesUsuallySpendAtom);
	const hasCouplesUsuallySpendValue = Boolean(
		couplesUsuallySpendDetailedPricing || couplesUsuallySpend,
	);
	const detailedPricingStartingPrice = useAtomValue(
		detailedPricingStartingCostAtom,
	);
	const venueStartingPrice = useAtomValue(startingCostAtom);
	const hasStartingPriceValue = Boolean(
		detailedPricingStartingPrice || venueStartingPrice,
	);

	return !(hasCouplesUsuallySpendValue || hasStartingPriceValue);
};
